// extracted by mini-css-extract-plugin
module.exports = {"nav":"_4e8c6cd","navList":"_666bdb9","navItem":"_8d2177d","navItemActive":"_0f291da","arrowButton":"_141bbb2","arrowButtonActive":"_b637095"};